import axios from 'axios';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const API = `${BACKEND_URL}/api`;
export const backendConfigured = Boolean(BACKEND_URL);

const requireBackend = () => {
  if (!backendConfigured) throw new Error('Thomas API not configured');
};

export async function getConfig() {
  requireBackend();
  const { data } = await axios.get(`${API}/config`);
  return data;
}

export async function getLiveState() {
  requireBackend();
  const { data } = await axios.get(`${API}/live-state`);
  return data;
}

export async function simSetMcap(mcapUsd) {
  requireBackend();
  const { data } = await axios.post(`${API}/sim/set-mcap`, { mcapUsd });
  return data;
}

export async function simReset() {
  requireBackend();
  const { data } = await axios.post(`${API}/sim/reset`);
  return data;
}

export async function resolveTicket(publicKey) {
  requireBackend();
  const { data } = await axios.post(`${API}/ticket/resolve`, { publicKey });
  return data;
}
